import { render } from "./VipLogsList.vue?vue&type=template&id=e6718424"
import script from "./VipLogsList.vue?vue&type=script&lang=js"
export * from "./VipLogsList.vue?vue&type=script&lang=js"

import "./VipLogsList.vue?vue&type=style&index=0&id=e6718424&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__